<div class="banner" [style.background]="backgroundImageURL">
    <div class="overlay"></div>
    <div class="main-content">
        <h1>Nepal's Leading Real Estate Portal</h1>
        <p class="mb-5"><small>by</small> NEPAL PROPERTY SERVICES (NEPROSE)</p>
        <form [formGroup]="searchForm">
            <input type="text" formControlName="keyword" placeholder="Keywords or location">
            <select formControlName="district">
                <option value="null" [selected]="true" disabled>Select District</option>
                <option *ngFor="let district of districtList" [value]="district.id">{{ district.district }}</option>
            </select>
            <select formControlName="type">
                <option value="null" [selected]="true" disabled>Select Property Type</option>
                <option *ngFor="let type of propertyTypes" [value]="type.id">{{ type.type }}</option>
            </select>
            <select formControlName="listingFor">
                <option value="null" [selected]="true" disabled>Listed For</option>
                <option value="sell">Sale</option>
                <option value="rent">Rent</option>
                <option value="rent">Share</option>
            </select>
            <button type="button" (click)="search()">Search&nbsp;&nbsp;<img src="assets\search-white.png" width="20px" height="20px" style="margin-top: -4px;"></button>
        </form>
    </div>
</div>
